var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'node-button', _vm.item.classes, { inactive: _vm.inactive } ]},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$getLocaleString(_vm.item.string))}}),_c('div',{staticClass:"overlay",on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }